import { createContext } from 'react';
export const TrackingContext = createContext({
    initTracker: () => undefined,
    sendTrackingEvent: () => undefined,
    sendImpressionEvent: () => undefined,
    trackingObserver: null,
});
